import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import * as Api from "../../Apis";
import Images from '../common/Index';
import { Helmet } from "react-helmet";
import { useMediaQuery } from '@uidotdev/usehooks';

function AdminLogin() {
    let navigate = useNavigate()
    const [value, setValue] = useState({})
    const [btnLoader, setbtnLoader] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [show, setShow] = useState(false)
    const handleOnchange = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value });
        if (e.target.name == "password") {
            if (e.target.value !== "") {
                setShowPassword(true)
            } else {
                setShowPassword(false)
            }
        }
    }
    const changeVisibility = () => {
        setShow(!show)
    }
    // useEffect(()=>{        
    //     localStorage.clear()
    // },[])

    const handleSubmit = (e) => {
        e.preventDefault();
        let data = {}
        if (value?.email == "") {
            Api.Alert("Please enter your email", "error")
        } else if (value?.password == "") {
            Api.Alert("Please enter your password", "error")
        } else {
            setbtnLoader(true)
            data = {
                ...value
            }
            Api.PostApiAdmin("administrative/login", data).then(res => {
                console.log("res login: ", res)
                setbtnLoader(false)
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data?.token) {
                        localStorage.clear()
                        localStorage["admin_token"] = res.data.data?.token
                        navigate("/admin/users")
                    }
                }
            })
            // }
        }
    }
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    console.log("value: ", value)
    return (
        <div className='loginContainer_outer'>
            <img src={Images.login_bg} alt="" className='login_bg' />
            <div className='loginContainer'>
                <Helmet>
                    <title>Shopyxa | Administrator</title>
                </Helmet>
                <div className="cardBox cardBox__login" >
                    <div className='loginLogo'>
                        <img src={prefersDarkMode ? Images?.logo_white : Images.logo} alt="" width="130" />
                    </div>
                    <div className='cardBoxStore__bodyHeading'>
                        <h4>Welcome Shopyxa Administrator</h4>
                    </div>

                    <form onSubmit={handleSubmit} className='login_outer' >
                        <div className='form-group mb-3'>
                            <div>
                                <input placeholder='Email' type="email" className='form-control' value={value?.email} name="email" onChange={handleOnchange} required />
                            </div>
                        </div>
                        <div className='form-group mb-3'>
                            <div className='flex_input'>
                                <input placeholder='Password' type={show ? "text" : "password"} className='form-control' value={value?.password} name="password" onChange={handleOnchange} required />
                                {/* {showPassword && */}
                                <span className="form-addon-icon" onClick={changeVisibility}>
                                    {!show ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                                </span>
                                {/* } */}
                            </div>
                        </div>

                        <div className='form-group mb-3'>
                            <button className={`btn btn-primary w-100 ${btnLoader ? "disabled" : ""}`}>Log in</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;